import "core-js/stable";
import "regenerator-runtime/runtime";
import axios from 'axios'

window.axios = axios
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
